const style = {
  insightsControls__dropdown: {
    zIndex: '3500',
  },
};

export default style;
